import { reactive } from "vue";

export const teamChatUi = reactive({
  activeChatIds: [],
  minimizedChatIds: [],
  focusedChatId: null,
  hydratedKey: null,
});

function storageKeyFor(userId, labId) {
  if (!userId || !labId) return null;
  return `team-chat-ui:${userId}:${labId}`;
}

function readStoredIds(key) {
  try {
    const parsed = JSON.parse(window.localStorage.getItem(key) || "[]");
    return Array.isArray(parsed)
      ? parsed.filter((id) => typeof id === "string" && id.length > 0)
      : [];
  } catch {
    return [];
  }
}

export function hydrateTeamChatUi(userId, labId) {
  const key = storageKeyFor(userId, labId);
  if (!key || teamChatUi.hydratedKey === key || typeof window === "undefined") return;
  teamChatUi.activeChatIds = readStoredIds(key);
  teamChatUi.minimizedChatIds = [];
  teamChatUi.focusedChatId = teamChatUi.activeChatIds[0] || null;
  teamChatUi.hydratedKey = key;
}

export function persistTeamChatUi() {
  if (!teamChatUi.hydratedKey || typeof window === "undefined") return;
  window.localStorage.setItem(teamChatUi.hydratedKey, JSON.stringify(teamChatUi.activeChatIds));
}

export function openTeamChat(participantId, options = {}) {
  if (!participantId) return;
  if (!teamChatUi.activeChatIds.includes(participantId)) {
    teamChatUi.activeChatIds.push(participantId);
  }
  teamChatUi.minimizedChatIds = teamChatUi.minimizedChatIds.filter((id) => id !== participantId);
  if (options.focus !== false) teamChatUi.focusedChatId = participantId;
  persistTeamChatUi();
}

export function closeTeamChat(participantId) {
  teamChatUi.activeChatIds = teamChatUi.activeChatIds.filter((id) => id !== participantId);
  teamChatUi.minimizedChatIds = teamChatUi.minimizedChatIds.filter((id) => id !== participantId);
  if (teamChatUi.focusedChatId === participantId) {
    teamChatUi.focusedChatId = teamChatUi.activeChatIds[0] || null;
  }
  persistTeamChatUi();
}

export function setFocusedTeamChat(participantId) {
  teamChatUi.focusedChatId = participantId || null;
  if (participantId) {
    teamChatUi.minimizedChatIds = teamChatUi.minimizedChatIds.filter((id) => id !== participantId);
  }
}

export function toggleMinimizedTeamChat(participantId) {
  if (teamChatUi.minimizedChatIds.includes(participantId)) {
    teamChatUi.minimizedChatIds = teamChatUi.minimizedChatIds.filter((id) => id !== participantId);
    teamChatUi.focusedChatId = participantId;
  } else {
    teamChatUi.minimizedChatIds.push(participantId);
    if (teamChatUi.focusedChatId === participantId) teamChatUi.focusedChatId = null;
  }
}
